import React from 'react';

export default function PageContainer({ children }) {
  return (
    <main className="flex-1 overflow-y-auto p-6 bg-gray-50">
      {children}
    </main>
  );
}
